import { NgModule } from '@angular/core';
import { LoginComponent } from './login.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TextfieldComponent } from 'src/app/shared/form/textfield/textfield.component';
import { ButtonModule } from 'src/app/shared/form/button/button.module';

@NgModule({
    declarations: [
        LoginComponent
    ],
    imports: [
        SharedModule,
        ButtonModule,
        TextfieldComponent
    ],
})
export class LoginModule { }